/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Ndauploadsuccess3Inputs */

const en_coinvestments_ndauploadsuccess3 = /** @type {(inputs: Coinvestments_Ndauploadsuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA document uploaded successfully`)
};

/**
* | output |
* | --- |
* | "NDA document uploaded successfully" |
*
* @param {Coinvestments_Ndauploadsuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndauploadsuccess3 = /** @type {((inputs?: Coinvestments_Ndauploadsuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndauploadsuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndauploadsuccess3(inputs)
});
export { coinvestments_ndauploadsuccess3 as "coInvestments_ndaUploadSuccess" }